import type {
  DefaultError,
  UseMutationOptions,
} from '@tanstack/react-query'
import type {
  PostRegisterQuery,
  PostRegisterResponse,
} from '~/lib/services/api/user'

import type { PostRegisterRequest } from '~/modules/register/register-form/constants'
import {
  useMutation,
} from '@tanstack/react-query'
import {
  postRegister,
} from '~/lib/services/api/user'

function useRegister() {
  const mutationFn: PostRegisterQuery = async (newData) => {
    const response = await postRegister(newData)
    return response.data
  }

  const options: UseMutationOptions<
    PostRegisterResponse,
    DefaultError,
    PostRegisterRequest,
    unknown
  > = {
    mutationFn,
  }

  return useMutation(options)
}

export default useRegister
